module.exports = __webpack_public_path__ + "img/platina.a01b1916.png";